import React from "react";
import { FaSchool, FaCog, FaUserShield, FaLock, FaInfoCircle } from "react-icons/fa";
import "./Definicoes.css";

const Definicoes = () => {
  return (
    <div className="definicoes-container">
      <h2>Definições do Sistema</h2>

      <div className="definicoes-grid">
        
        <div className="definicao-card">
          <FaSchool size={30} />
          <h3>Dados da Escola</h3>
          <p>Nome da escola, contactos, logotipo e ano letivo.</p>
          <button>Configurar</button>
        </div>

        <div className="definicao-card">
          <FaCog size={30} />
          <h3>Configurações Gerais</h3>
          <p>Idioma, moeda, módulos ativos e preferências.</p>
          <button>Configurar</button>
        </div>

        <div className="definicao-card">
          <FaUserShield size={30} />
          <h3>Perfis & Permissões</h3>
          <p>Controle de acesso dos usuários do sistema.</p>
          <button disabled>Em breve</button>
        </div>

        <div className="definicao-card">
          <FaLock size={30} />
          <h3>Segurança</h3>
          <p>Senha, sessões e políticas de segurança.</p>
          <button disabled>Em breve</button>
        </div>

        <div className="definicao-card">
          <FaInfoCircle size={30} />
          <h3>Sobre o Sistema</h3>
          <p>Versão, informações técnicas e suporte.</p>
          <button>Ver detalhes</button>
        </div>

      </div>
    </div>
  );
};

export default Definicoes;
